import { useEffect, useRef } from 'react';
import { CONNECTION_TYPE, EMITTER_CONSTANTS } from '@/shared/config';
import { useEmitter, useNetworkState } from '@/shared/lib/customHooks';
import emitter from '@/shared/lib/eventEmitter';

/**
 * Watches for loss of network connectivity and forces a reload when it happens. Emits a lost-connection event, alerts the user and reloads the page once the browser reports itself offline, and remembers a socket-originated disconnect from the same emitter event.
 *
 * @returns Null, since the component renders nothing.
 */
const NetWorkState = (): null => {
  const stateNetWork = useNetworkState();

  const { online } = stateNetWork;
  const isSocketDisconnected = useRef(false);

  useEffect(() => {
    if (!online && !isSocketDisconnected.current) {
      emitter.emit(EMITTER_CONSTANTS.LOST_CONNECTION, CONNECTION_TYPE.NETWORK);
      alert('Network Connection Error');
      window.location.reload();
    }
  }, [online]);

  useEmitter(EMITTER_CONSTANTS.LOST_CONNECTION, (msg) => {
    if (msg === CONNECTION_TYPE.SOCKET) {
      isSocketDisconnected.current = true;
    }
  });

  return null;
};

export default NetWorkState;
